import useSyncChartSetSelectionDefaults from "components/charting/hooks/useSyncChartSetSelectionDefaults";

interface ChartSetSelectionDefaultsProviderProps {
  children?: React.ReactNode;
}

/**
 * Applies the set selection defaults above the chart controls, so switching chart types doesn't remount it and
 * reapply them for the same athlete and exercise.
 */
function ChartSetSelectionDefaultsProvider(props: ChartSetSelectionDefaultsProviderProps) {
  useSyncChartSetSelectionDefaults();
  return <>{props.children}</>;
}

export default ChartSetSelectionDefaultsProvider;
